import { Injectable } from '@angular/core';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from '../../../shared/services/loca-storage.service';
import { isNull } from 'util';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from './user';
import { AlertService } from '../../../shared/services/alert.service';
const HEADERS = {};

@Injectable()
export class AuthService {
    static ENV: any = environment;
    
    public user = new BehaviorSubject<any>(null);
    public tokenUser: any;
    public currentUserSubject: BehaviorSubject<User>;
    public currentUserSubjectLoc: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private userLoca: User;
    private valSesion: any;
    private ASSET_PERMISSIONS : any = null;
    constructor(
        private httpProvider: HttpService,
        private storageService: LocalStorageService,
        private http: HttpClient,
        private _alertService: AlertService,
    ) {
        HEADERS['Content-Type'] = 'application/json';
        //this.getTokenUser();
        this.currentUserSubjectLoc = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubjectLoc.asObservable();

        this.validateInsession();
    }

    public get currentUserValue(): User {
        return this.currentUserSubjectLoc.value;
    }

    public auth(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.LOGIN.login, data, httpRequesthandler);
    }
    public authJSon(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.get('assets/data/users.json', httpRequesthandler);
    }

    public generateTokenPassword(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.LOGIN.generateTokenPassword, data, httpRequesthandler);
    }
    public changePassword(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.LOGIN.changePassword, data, httpRequesthandler);
    }

    public isLogin(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let isLoged = !isNull(localStorage.getItem('auth_user'));
            resolve(isLoged)
        });
    }

    public setSession(data: any) {

        this.userLoca = new User();
        let info = data.data;
        this.valSesion = data.data;
        let session_cryp = this.valSesion.session;
        delete this.valSesion['session']

        this.userLoca.firstName = info.firstName;
        this.userLoca.lastName = info.lastName;
        this.userLoca.username = info.username;
        this.userLoca.id_usuario = info.id_usuario;
        this.userLoca.razonSocial = info.razon_social;
        this.userLoca.urlLogo = info.url_logo;
        this.userLoca.short_name = info.short_name;
        this.userLoca.datos_personales = info.datos_personales;
        this.userLoca.ind_estado = info.ind_estado;
        this.userLoca.ind_instancia = info.ind_instancia;

        if (!this.valSesion.url_logo || this.valSesion.url_logo == "") {
          this.userLoca.urlLogo = 'assets/images/logos/unknown.png';
          this.valSesion.url_logo = 'assets/images/logos/unknown.png';
        }

        localStorage.setItem('currentUser', JSON.stringify(this.userLoca));
        this.currentUserSubjectLoc.next(this.userLoca);

        this.init_assets_permissions();

        return new Promise((resolve, reject) => {
          localStorage.setItem('session', session_cryp);
          localStorage.setItem('auth_user', JSON.stringify(this.userLoca));
          this.storageService.save('auth_user', this.userLoca).then((resp) => {
                resolve(this.valSesion);
            }, err => {
                reject(false);
            });
        });
    }

    /* public setSessionLogin(data: any) {

        this.userLoca = new User();
        let info = data;
        this.userLoca.firstName = info.firstName;
        this.userLoca.lastName = info.lastName;
        this.userLoca.username = info.username;
        this.userLoca.token = info.token;
        this.userLoca.id_usuario = info.id_usuario;
        this.userLoca.token_pass = info.token_pass;
        localStorage.setItem('currentUser', JSON.stringify(this.userLoca));
        this.currentUserSubjectLoc.next(this.userLoca);
        
        return new Promise((resolve, reject) => {
            this.storageService.save('auth_user', data).then((resp) => {
                resolve(resp);
            }, err => {
                reject(false);
            });
        });
    } */

    public getSession() {
        return new Promise((resolve, reject) => {
            let sesion = localStorage.getItem('session');

            if (!this.valSesion && sesion) {
                this.decryptSession({ session: sesion },{
                    success: (resp) => {
                        if (resp.code && resp.code !== 0) {
                            this._alertService.openConfirmsSwal({
                                text: resp.msg,
                                type: 'error',
                                confirmButtonText: 'Aceptar',
                                handlerConfirm: () => {
                                this.removeToken()
                                },
                            });
                            return;
                        } else {
                            this.valSesion = resp.data.data;
                            this.init_assets_permissions();
                            resolve(this.valSesion);
                        }
                    },
                    error: (e) => {
                        console.log('Error decrypt session', e);
                    }
                    } );

                }else{
                    resolve(this.valSesion);
                }
        });
    }

    public getToken() {
        return new Promise((resolve, reject) => {
            this.getSession().then((resp: any) => {
                resolve(resp.token);
            });
        });
    }

    public getTokenUser() {

        return this.valSesion ? this.valSesion.token : null;
    }

    public rememberMe(data) {
        const remember = !data.remember
            ? {
                remember: false,
                username: '',
                password: ''
            } : {
                remember: true,
                username: data.username,
                password: data.password
            };

        this.storageService.save('remember', remember);
    }

    public logout(dataToken, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.LOGIN.logout, { app: AuthService.ENV.APP, token: dataToken }, httpRequesthandler);
    }

    removeToken() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('UserOnlyRead');
        localStorage.removeItem('auth_user');
        localStorage.removeItem('session');
        this.currentUserSubjectLoc.next(null);
        // this.storageService.clear();
        this.storageService.remove('changeCompany');
        this.storageService.remove('auth_user').then((res) => {
            this.user = null;
            // this.router.navigate(['/']);
            window.location.reload();
        });
    }


    newLogin(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.API.logoutForce, data, httpRequesthandler);
    }

    
  public usuariosCliente(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.post(AuthService.ENV.environment.USUARIOS_CLI.get_users, data, httpRequesthandler);
  }  

  public getentity(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.get(AuthService.ENV.environment.USUARIOS_CLI.get_entity, httpRequesthandler);
  }

  public guardarUserCli(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.post(AuthService.ENV.environment.USUARIOS_CLI.userEntity, data, httpRequesthandler);
  }  

  public usuariosUnidad(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.post(AuthService.ENV.environment.USUARIOS_CLI.get_usersUp, data, httpRequesthandler);
  }  
 

  public getAllUserUn(data: any, httpRequesthandler: HttpRequestHandler) {
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.post(AuthService.ENV.environment.USUARIOS_CLI.get_userUnityOp, data, httpRequesthandler);
  }  

    public decryptSession(data: any, httpRequesthandler: HttpRequestHandler) {
        httpRequesthandler.headers = HEADERS;
        this.httpProvider.post( AuthService.ENV.environment.LOGIN.decrypt_session, data, httpRequesthandler);   
    }

    public getShortName(): Promise<string> {
        return new Promise((resolve, reject) => {

            let short_name = 'default';
            let user = localStorage.getItem('currentUser');

            if(user){
                let userObj = JSON.parse(user);
                short_name = userObj.short_name;
            }
            resolve(short_name);           
        });
    }   

    public validateInsession(){
        let localUser = localStorage.getItem('currentUser');
        console.log(AuthService.ENV.environment)
        if(localUser && AuthService.ENV.environment){
            this.getSession();
        }
    }


    init_assets_permissions(){
        if(!this.ASSET_PERMISSIONS){

            let pay_load = {
                "lookup_type" : "ASSET_PERMISSION",
                "lookup_code": "PERMISSIONS"};
            
            let url = AuthService.ENV.environment.API.asset_lookup_value;

            this.httpProvider.post( url, 
                                    pay_load, 
                                    {
                                        headers: HEADERS,
                                        success : (resp) => {
                                            if(resp.status){
                                                this.default_permissions();
                                                return;
                                            }

                                            this.ASSET_PERMISSIONS = {};
                                            let data = JSON.parse(resp.data.attribute1_text);
                                            this.ASSET_PERMISSIONS = data;

                                        },
                                        error:(error: any) => {
                                            console.error('Error en el consumo del servicio de consulta ==>',error);
                                            this.default_permissions();
                                        }
                                    });  
            
        }
    }


    default_permissions(){

        this.ASSET_PERMISSIONS = {
            /**
             * Objeto con los perfiles que tiene permisos por cado opcion
             */
            PERMISSIONS_MODULE : {
            'IDENTIFACION-ACTIVO' : [66,67],
            'UBICACION-RESPONSABLES' : [66,67],
            'PURCHASE' : [66,67]
            },

            /**
             * Objeto con las rutas que necesitan permisos
             */
            ROUTES_PERMISSION : {
            '/active-resume/load-employees': [66,67],
            '/active-resume/load-locations': [66],
            '/active-resume/create-employees': [66,67],
            '/active-resume/create-location': [66]
            }
        }
        
    }

    get_asset_permissions(){
        return this.ASSET_PERMISSIONS;
    }

    get_encrypted_session(){
        return localStorage.getItem('session');
    }

  
}




// WEBPACK FOOTER //
// ./src/app/core/services/auth/auth.service.ts